<script setup lang="ts">
import type { FasitSidenote } from "~/models/FasitSidenote"

defineProps({
  note: {
    type: Object as PropType<FasitSidenote>,
    required: true,
  },
})
</script>

<template>
  <USidenote :note="note" title-class="text-[--theme-darker]">
    <template #content>
      <URichText
        class="!font-national2 !text-mobile-sidenote-p1 lg:!text-desktop-sidenote-p1"
        :html="note.solutionText"
      />
    </template>
  </USidenote>
</template>
